/* src/app/core/components/expires-privilege-dialog/expires-privilege-dialog.component.scss */
/*# sourceMappingURL=expires-privilege-dialog.component.css.map */
